"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCombo = instanceOfCombo;
exports.ComboFromJSON = ComboFromJSON;
exports.ComboFromJSONTyped = ComboFromJSONTyped;
exports.ComboToJSON = ComboToJSON;
exports.ComboToJSONTyped = ComboToJSONTyped;
/**
 * Check if a given object implements the Combo interface.
 */
function instanceOfCombo(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function ComboFromJSON(json) {
    return ComboFromJSONTyped(json, false);
}
function ComboFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
function ComboToJSON(json) {
    return ComboToJSONTyped(json, false);
}
function ComboToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {};
}
//# sourceMappingURL=combo.js.map